import type { ViewJobReadableCookies } from "../../../shared/native-modules/core/getCookies";

import { CookieKey } from "../../../shared/native-modules/types/RNCoreNativeModule";
import { useCookies } from "../../../shared/util/CookieProvider";

/**
 * Mirrors the canonical server-side check in `DsanrCookieUtil.isValidDsanr`:
 * the DSANR cookie is only considered active when its value is the exact
 * string "1". Any other value (including other non-zero numbers), missing,
 * or empty values are not DSANR.
 */
export function isDsanrCookieActive(dsanrCookieValue: string | null | undefined): boolean {
  return dsanrCookieValue === "1";
}

/**
 * Whether the user has opted out of personalized recommendations via the
 * DSANR (Digital Services Act "No Recommend") cookie.
 */
export function useDsanrCookie(): boolean {
  const cookies = useCookies<ViewJobReadableCookies>();
  return isDsanrCookieActive(cookies[CookieKey.dsaCompliant]);
}

/**
 * Whether the desktop two-pane "dislike" action should be available.
 * Disabled when DSANR is active, since dislike drives future recommendations.
 */
export function useIsDislikeFrom2PaneEnabled(): boolean {
  return !useDsanrCookie();
}
